import MainPageFrame from '../../_common/elements/MainPageFrame';

function Invoice() {
    const data = {
        title: 'Overview',
        address: '/invoice',
    };
    return <MainPageFrame data={data} />;
}

export default Invoice;
